import React, {SyntheticEvent} from "react";

import {UiState} from "../../../ui-state";

import {Button, Form} from "semantic-ui-react";
import {Icon} from "../../icon/icon";
import {autorun} from "mobx";

interface MeasurementButtonsProperties {
    active: boolean;
    uiStore: UiState;
    onClick: (tool: string | null, subTool?: string) => void;
    small?: boolean;
}
interface MeasurementStates {
    active: boolean;
    activeTool?: "area" | "distance";
}

export class MeasurementButtons extends React.Component<MeasurementButtonsProperties, any> {
    state: MeasurementStates;
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    constructor(props: MeasurementButtonsProperties) {
        super(props);
        this.state = {
            active: this.props.active,
            activeTool: undefined
        };
        this.handleClick=this.handleClick.bind(this);
    }
    handleClick(tool: "area" | "distance", event?: SyntheticEvent<HTMLButtonElement>): void {
        const {small, uiStore} = this.props;
        if (event) {
            event.currentTarget.blur();
        }
        const {active, activeTool} = this.state;
        let newActive: boolean;
        let newActiveTool: "area" | "distance" | undefined;
        if (active){
            if (tool !== undefined && tool!==activeTool) {
                newActive = true;
                newActiveTool = tool;
            } else {
                newActive = false;
                newActiveTool = undefined;
            }
        } else {
            newActive = true;
            newActiveTool = tool;
        }
        this.setState({active: newActive, activeTool: newActiveTool});
        if (newActive) {
            if (small) {
                uiStore.setSidebarVisible(false);
            }
            this.props.onClick("measurement", newActiveTool);
        } else {
            this.props.onClick(null);
        }
    }
    componentDidMount(): void {
        autorun(() => {
            const {uiStore} = this.props;
            if (uiStore.activeTool.indexOf("measurement")===0) {
                const activeTool = uiStore.activeTool.substring(12);
                if (activeTool === "distance" || activeTool === "area"){
                    this.setState({active: true, activeTool});
                }
            } else {
                this.setState({active: false});
            }
        });
    }
    componentDidUpdate(prevProps: MeasurementButtonsProperties): void {
        if(prevProps.active !== this.props.active && this.state.active !== this.props.active){
            this.setState({active: this.props.active});
        }
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
    }

    render(): JSX.Element | null {
        const {active, activeTool} = this.state;
        return (
            <Form size={"small"} className={"geo-measurement-buttons"}>
                <Form.Field>
                    <label>Messen</label>
                    <Button
                        active={active && activeTool === "distance"}
                        compact
                        toggle
                        onClick={(e)=>this.handleClick("distance", e)}
                        size={"small"}>
                        <Icon name={"tape_measure2"}/> Strecke</Button>
                    <Button
                        active={active && activeTool === "area"}
                        compact
                        toggle
                        onClick={(e)=>this.handleClick("area", e)}
                        size={"small"}>
                        <Icon name={"vector_square"}/> Fläche</Button>
                </Form.Field>
            </Form>
        );
    }
}
